import { Box, styled } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { NEUTRAL, SURFACE } from "../../theme/tokens";

/**
 * A styled Box component for common dashboard boxes with consistent styling.
 * If you want to customize the styles, you can override them using the `sx` prop when using this component.
 */
export const CommonDashboardBox = styled(Box)(({ theme }) => ({
	boxShadow: `0px 1px 8px 0px ${alpha(NEUTRAL[600], 0.1)}`,
	background: SURFACE,
	borderRadius: "8px",
	width: "fit-content",
	height: "fit-content",
	padding: "8px 16px",
	[theme.breakpoints.up("xxl")]: {
		padding: "20px",
	},
}));

export const MultiCommonDashboardBox = styled(Box)(({ theme }) => ({
	boxShadow: `0px 1px 8px 0px ${alpha(NEUTRAL[600], 0.1)}`,
	background: SURFACE,
	borderRadius: "8px",
	width: "fit-content",
	padding: "16px",
	[theme.breakpoints.up("xxl")]: {
		padding: "20px",
	},
}));
